import { render } from "./JobNotEditableUserInfo.vue?vue&type=template&id=e2b21db8&scoped=true"
const script = {}

import "./JobNotEditableUserInfo.vue?vue&type=style&index=0&id=e2b21db8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b21db8"]])

export default __exports__